<template>
  <div class="viewDimission">
    <el-row :gutter="10">
      <OACard header="基本信息" :col="24">
        <form-component :form-data="formData" ref="formData" label-width="150px"></form-component>
      </OACard>
      <otherInfo :userId="userId" :evaluate="false" :readonly="true"></otherInfo>
    </el-row>
  </div>
</template>
<script>
import OACard from "@/components/OACard/OACard";
import { getUrlQuery } from "@/common/util.js";
import otherInfo from "@/components/otherTable/otherInfo";
import formComponent from "@/components/formComponents/form-component";
import staffApi from "@/services/staff.js";

export default {
  name: "viewDimission",
  components: { OACard, otherInfo, formComponent },
  data() {
    return {
      formData: {},
      userId: ""
    };
  },
  methods: {
    async getDetail(id) {
      this.userId = id;
      let res = await staffApi.getDetail({ id: id });
      let detail = res.data.data;
      this.formData = {
        name: {
          formType: "a-span",
          label: "真实姓名：",
          col: 8,
          value: detail.name || "-"
        },
        englishName: {
          formType: "a-span",
          label: "英文名：",
          col: 8,
          value: detail.englishName || "-"
        },
        sex: {
          formType: "a-span",
          label: "性别：",
          col: 8,
          value: detail.sexName || "-"
        },
        number: {
          formType: "a-span",
          label: "工号：",
          col: 8,
          value: detail.number || "-"
        },
        employeeTypeName: {
          formType: "a-span",
          label: "员工类型：",
          col: 8,
          value: detail.employeeTypeName || "-"
        },
        inductionTime: {
          formType: "a-span",
          label: "入职日期：",
          col: 8,
          value: detail.inductionTime || "-"
        },
        companyName: {
          formType: "a-span",
          label: "所在公司：",
          col: 8,
          value: detail.companyName || "-"
        },
        departmentName: {
          formType: "a-span",
          label: "所在部门：",
          col: 8,
          value: detail.departmentName || "-"
        },
        positionName: {
          formType: "a-span",
          label: "职位：",
          col: 8,
          value: detail.positionName || "-"
        },
        uniqueCode: {
          formType: "a-span",
          label: "身份证号：",
          col: 8,
          value: detail.uniqueCode || "-"
        },
        mobile: {
          formType: "a-span",
          label: "联系电话：",
          col: 8,
          value: detail.mobile || "-"
        },
        birthDate: {
          formType: "a-span",
          label: "出生年月：",
          col: 8,
          value: detail.birthDate || "-"
        },
        nationName: {
          formType: "a-span",
          label: "民族：",
          col: 8,
          value: detail.nationName || "-"
        },
        politicalName: {
          formType: "a-span",
          label: "政治面貌：",
          col: 8,
          value: detail.politicalName || "-"
        },
        maritalName: {
          formType: "a-span",
          label: "婚姻状况：",
          col: 8,
          value: detail.maritalName || "-"
        },
        place: {
          formType: "a-span",
          label: "籍贯：",
          col: 8,
          value: detail.place || "-"
        },
        idcardAddr: {
          formType: "a-span",
          label: "身份证地址：",
          col: 8,
          value: detail.idcardAddr || "-"
        },
        nowAddr: {
          formType: "a-span",
          label: "现居住地址：",
          col: 8,
          value: detail.nowAddr || "-"
        },
        bankNumber: {
          formType: "a-span",
          label: "银行卡号：",
          col: 8,
          value: detail.bankNumber || "-"
        },
        companyEmail: {
          formType: "a-span",
          label: "企业邮箱：",
          col: 8,
          value: detail.companyEmail || "-"
        },
        doorcardNumber: {
          formType: "a-span",
          label: "门禁卡编号：",
          col: 8,
          value: detail.doorcardNumber || "-"
        },
        emergencyContact: {
          formType: "a-span",
          label: "紧急联系人：",
          col: 8,
          value: detail.emergencyContact || "-"
        },
        emergencyPhone: {
          formType: "a-span",
          label: "紧急联系方式：",
          col: 8,
          value: detail.emergencyPhone || "-"
        },
        remark: {
          formType: "a-span",
          value: detail.remark || "-",
          col: 8,
          label: "离职备注："
        },
        recommend: {
          formType: "sky-upload-img",
          label: "离职附件：",
          col: 8,
          disabled: true,
          value: detail.recommend,
          platform: 'oa-pri-oss',
        }
      };
    }
  },
  mounted() {
    this.query = getUrlQuery();
    this.query.userId && this.getDetail(this.query.userId);
  }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/personnel/dimissionDetail.vue